import { render, staticRenderFns } from "./registrar_baixa.vue?vue&type=template&id=c1f21214"
import script from "./registrar_baixa.js?vue&type=script&lang=js&external"
export * from "./registrar_baixa.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports